import { FlagsManager } from './index'

const FlagsSingleton = new FlagsManager()
export default FlagsSingleton
